import { useMutation, useQueryCache } from 'react-query';
import { JudgeAPI } from 'api/admin/judge';
import { JUDGES } from 'helpers/constants';
import dispatchToast from 'helpers/dispatchToast';

export default function useRemoveJudge() {
  const queryCache = useQueryCache();

  return useMutation(JudgeAPI.remove, {
    onSuccess: ({ message }, { onSuccess = () => {} }) => {
      queryCache.invalidateQueries(JUDGES);
      dispatchToast({ message, type: 'success' });
      onSuccess();
    },
  });
}
